<template><!-- svgo-optimised -->
<svg class="icon icon__minus" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 12.5H4v-1h16v1Z" fill-rule="evenodd" clip-rule="evenodd"/></svg></template>